/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from "react-overlay-loader";
import maleAvatar from "../../assets/images/Male-Avatar.png";
import computerIcon from '../../assets/images/computer-icon-hover.png'
import alertsIcon from '../../assets/images/alerts-icon-active.png'
import * as actions from "../../store/actions";
import Error from "../../components/UI/Error";
import moment from "moment";

class Alerts extends Component {
    intervalID;
    state = {
        alerts: this.props.alerts,
        filter: "",
    };

    componentDidMount() {
        window.$(function () {
            window.jcf.replaceAll();
        });

        window.$(function () {
            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            });

        });

        // this.intervalID = setInterval(this.fetchAlerts.bind(this), 30000);
    }

    componentWillMount() {
        this.props.onFetchAlerts(this.props.token, this.state.filter, 1)
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            alerts: props.alerts
        });
    }

    componentWillUnmount() {
        /*
          stop getData() from continuing to run even
          after unmounting this component
        */
        // clearInterval(this.intervalID);
    }

    fetchAlerts = () => {
        this.props.onFetchAlerts(this.props.token, this.state.filter, this.props.page);
    };

    handleRefreshAlerts = (e, page) => {
        e.preventDefault();
        this.props.onFetchAlerts(this.props.token, this.state.filter, page)
    }

    handleEditAlertsFilter = (e) => {
        this.setState({filter: e.target.value})
    }

    handleFilter = (e) => {
        e.preventDefault();
        this.props.onFetchAlerts(this.props.token, this.state.filter, 1)
    }

    handleLogout = () => {
        this.props.onLogout(this.props.token)
    };

    formatDate = (x) => {
        if (x === null || x === 0 || x === undefined) {
            return ''
        }
        let y;
        if (typeof x === 'string') {
            return moment(x).format("YYYY-MM-DD HH:mm:ss z")
        } else {
            y = x;
        }
        let m = moment.unix(y).utc();
        return m.format("YYYY-MM-DD HH:mm z")
    };

    redirectToDashboard = (e) => {
        e.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToGcpDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/gcpDashboard")
    };

    redirectToSettings = (e) => {
        e.preventDefault();
        this.props.history.push("/accountSettings")
    };

    redirectToInstallation = (e) => {
        e.preventDefault();
        this.props.history.push("/installation")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToScheduler = (event) => {
        event.preventDefault();
        this.props.history.push("/schedulers")
    };

    redirectToBudget = (e) => {
        e.preventDefault();
        this.props.history.push("/budgets")
    };

    render() {
        return (
            <div>
                <div className="wrapper">
                    <Loader fullPage={true} loading={this.props.loading}/>
                    <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                        <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                            className="navbar-toggler-icon"></span></button>
                        <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                             href="http://example.com" id="dropdown10"
                                                                             data-toggle="dropdown" aria-haspopup="true"
                                                                             aria-expanded="false">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                              alt="" title=""/></div>
                            </div>
                            {this.props.company}</a>
                            <div className="dropdown-menu" aria-labelledby="dropdown10">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handlerLogout}>Logout</a></div>
                        </div>
                    </div>
                    <div className="sidebar offcanvas-collapse">
                        <div className="sidebar-wrapper">
                            <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                                className="simple-text dropdown-toggle"
                                                                                data-toggle="collapse"
                                                                                data-target="#dropdown11">
                                <div className="company-logo">
                                    <div className="inner-logo rounded-circle img-thumbnail"><img
                                        src={maleAvatar} alt="" title=""/></div>
                                </div>
                                {this.props.company} </a>
                                <div className="dropdown-menu collapse" id="dropdown11">
                                    <a className="dropdown-item" href="#">{this.props.company}</a>
                                    <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                                </div>
                            </div>
                            <ul className="nav">
                                {
                                    this.props.gcpOnly ? null :
                                        (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                            <p>AWS Dashboard</p>
                                        </a></li>)
                                }
                                {
                                    this.props.hasGcp ?
                                        (
                                            <li><a href="#" onClick={this.redirectToGcpDashboard}> <i className="fa fa-bar-chart"></i>
                                                <p>GCP Dashboard</p>
                                            </a></li>
                                        ) : null
                                }

                                <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                    src={computerIcon} alt="" title=""/></i>
                                    <p>Xogroups</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToBudget}> <i className="fa fa-dollar"></i>
                                    <p>Budgets</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToScheduler}> <i className="fa fa-calendar"></i>
                                    <p>Schedules</p>
                                </a></li>
                                <li className="active"><a href="#"> <i className="com-icon-active"><img
                                    src={alertsIcon} alt="" title="" width="25"/></i>
                                    <p>Alerts</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToInstallation}> <i className="fa fa-wrench"></i>
                                    <p>Installation</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToSettings}> <i className="fa fa-gear"></i>
                                    <p>Settings</p>
                                </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-panel">
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters mb-2">
                                                        <div className="col-5 col-lg-8">
                                                            <h4 className="title mt-2 mb-3">Alerts</h4>
                                                        </div>
                                                        <div className="col-7 col-lg-4 text-right">
                                                            <button type="submit"
                                                                    onClick={e => this.handleRefreshAlerts(e, 1)}
                                                                    className="btn btn-primary">Refresh
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Error errorMsg={this.props.error} divClass="col-lg-5 col-sm-6 col-center"/>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Object Type</th>
                                                        <th>Object Name</th>
                                                        <th>Event</th>
                                                        <th>Description</th>
                                                        <th>Time</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.alerts.map((b, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td data-title="Object Type" width="130">{b.type}</td>
                                                                <td data-title="Object Name" width="130">{b.name}</td>
                                                                <td data-title="Event" width="130">{b.event}</td>
                                                                <td data-title="Description">{b.description}</td>
                                                                <td data-title="Time"width="200">{this.formatDate(b.timestamp)}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </table>
                                                {this.props.maxPage > 0 ?
                                                    <div className="mb-3">
                                                        <nav aria-label="...">
                                                            <ul className="pagination justify-content-center">
                                                                <li className={this.props.page === 1 ? 'page-item disabled' : 'page-item'}>
                                                                    <a className="page-link" onClick={e => this.handleRefreshAlerts(e, 1)}
                                                                       href="#" page="-1"
                                                                       aria-label="First">
                                                                        <span aria-hidden="true">&laquo;</span>
                                                                        <span className="sr-only">First</span>
                                                                    </a>
                                                                </li>
                                                                <li className={this.props.page === 1 ? 'page-item disabled' : 'page-item'}>
                                                                    <a className="page-link" onClick={e => this.handleRefreshAlerts(e, this.props.page - 1)}
                                                                       href="#" page="-1"
                                                                       aria-label="Previous">
                                                                        <span aria-hidden="true">&lsaquo;</span>
                                                                        <span className="sr-only">Previous</span>
                                                                    </a>
                                                                </li>
                                                                {this.props.pageItems.map((p, i) => {
                                                                    return (<li key={i} className={(p) === this.props.page ? "page-item active" : "page-item"}><a
                                                                        className="page-link" onClick={e => this.handleRefreshAlerts(e, p)}
                                                                        href="#" page={this.props.page}>{p} {(p) === this.props.page ? (<span
                                                                        className="sr-only">(current)</span>): null}</a></li>)
                                                                })}
                                                                <li className={this.props.page === this.props.maxPage ? 'page-item disabled' : 'page-item'}>
                                                                    <a className="page-link" onClick={e => this.handleRefreshAlerts(e, this.props.page + 1)}
                                                                       href="#" page="-2" aria-label="Next">
                                                                        <span aria-hidden="true">&rsaquo;</span>
                                                                        <span className="sr-only">Next</span>
                                                                    </a>
                                                                </li>
                                                                <li className={this.props.page === this.props.maxPage ? 'page-item disabled' : 'page-item'}>
                                                                    <a className="page-link" onClick={e => this.handleRefreshAlerts(e, this.props.maxPage)}
                                                                       href="#" page="-2" aria-label="Last">
                                                                        <span aria-hidden="true">&raquo;</span>
                                                                        <span className="sr-only">Last</span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    let maxPage = state.alerts.alerts.totalSize ? Math.ceil(state.alerts.alerts.totalSize / state.alerts.alerts.pageSize) : 0;
    let currentPage = state.alerts.alerts.page ? state.alerts.alerts.page : 0;
    let pageItems = [];
    let startPage = 1;
    let endPage = maxPage;
    if (endPage - startPage > 5) {
        let highHalf =  endPage - currentPage;
        let lowHalf = currentPage - startPage;
        if (highHalf <=2 ) {
            [...Array(5).keys()].reverse().forEach(i =>
                pageItems.push(endPage - i)
            )
        } else if (lowHalf <= 2) {
            [...Array(5).keys()].forEach(i =>
                pageItems.push(startPage + i)
            )
        } else {
            pageItems.push(currentPage-2)
            pageItems.push(currentPage-1)
            pageItems.push(currentPage)
            pageItems.push(currentPage+1)
            pageItems.push(currentPage+2)
        }
    } else {
        for (let i = startPage; i<= endPage; i++) {
            pageItems.push(i);
        }
    }
    return {
        token: state.settings.token || state.login.token,
        loading: state.alerts.loading,
        error: state.alerts.error,
        company: state.login.company,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        alerts: state.alerts.alerts.alerts || [],
        page: currentPage,
        maxPage: maxPage,
        pageItems: pageItems,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchAlerts: (token, filter, page) => dispatch(actions.fetchAlerts(token, filter, page)),
        onLogout: (token) => dispatch(actions.logout(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts)